import { ArrowLeft } from "@carbon/icons-react";
import { IconButton } from "@carbon/react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { useT } from "src/internationalization";

type BackButtonProps = {
  dataTestid?: string;
};

export const BackButton: React.FC<BackButtonProps> = ({ dataTestid }) => {
  const navigate = useNavigate();
  const t = useT();

  return (
    <IconButton
      data-testid={dataTestid}
      onClick={() => {
        navigate(-1);
      }}
      size="lg"
      label={t("component.button.back")}
      kind="ghost"
    >
      <ArrowLeft />
    </IconButton>
  );
};
